module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAVCAYAAABLy77vAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAEqADAAQAAAABAAAAFQAAAAALQUx/AAAATklEQVQ4EWNkIAJIFz1bTEgZEyEFxMqPGkQ4pAZfGDFKFT/7T8jhz3qlGAmpGXxeG3URoThjYBiiYSRV/DQShPF5kAVfqiWkGdngwRdGAGpXDTA4Qyx2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsTitle.png
// module id = F3Xr
// module chunks = 2